import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import InstitutionPageHeader from '../../components/InstitutionPageHeader';

/**
 * Placeholder for full activity log (future).
 */
const CodingActivityPage = () => (
  <Box sx={{ px: { xs: 2, md: 3 }, maxWidth: 1200, mx: 'auto', pb: 4 }}>
    <InstitutionPageHeader />
    <Button
      component={RouterLink}
      to="/faculty/coding/overview"
      startIcon={<ArrowBackRoundedIcon />}
      size="small"
      sx={{ mb: 2, textTransform: 'none', fontWeight: 600 }}
    >
      Back to overview
    </Button>
    <Typography variant="h5" fontWeight={700} sx={{ mb: 1, letterSpacing: '-0.02em' }}>
      Activity log
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 560 }}>
      A full searchable history is coming soon. For now, use Recent activity on the coding overview page.
    </Typography>
  </Box>
);

export default CodingActivityPage;
